$(document).on("taydu2_cuuthienhuyennu_kimtuong rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
});